import React from 'react';
import {CustomizeItemContext} from '../../../CustomizeItemContext';
import SelectedCustomizeItemSelectOptions from '../SelectedCustomizeItemSelectOptions';

export default () => {
  const {poolProspectCustomizeItem} = React.useContext(CustomizeItemContext);
  return (
    <>
      <div className="bg-[#F3F5F7] border-c-border w-40 text-center mb-2">
        <div>選択中の{poolProspectCustomizeItem?.name}</div>
      </div>
      <SelectedCustomizeItemSelectOptions />
    </>
  );
};
